import axios from "axios";

const isDev = process.env.NODE_ENV === "development";
console.log(process.env.NODE_ENV);

const configCommon = {
  baseURL: isDev ? "/api" : process.env.HOST_MONITOR?.toString(),
  withCredentials: true
};

const axiosInstance = axios.create(configCommon);

export default axiosInstance;
